import { Injectable } from '@angular/core';
import { ServiceGroup } from '@quorum/models/xs-resource';
import { Store, select } from '@ngrx/store';
import * as fromAcceptedServices from './+state/accepted-services/accepted-services.actions';
import { selectAll as selectAcceptedServices } from './+state/accepted-services/accepted-services.interfaces';
import * as fromDeclinedServices from './+state/declined-services/declined-services.actions';
import { selectAll as selectDeclinedServices } from './+state/declined-services/declined-services.interfaces';
// eslint-disable-next-line max-len
import { selectEntities as selectMaintenanceSchedule } from './+state/maintenance-schedule/maintenance-schedule.interfaces';
import * as fromMaintenanceSchedule from './+state/maintenance-schedule/maintenance-schedule.actions';
import * as fromPendingAcceptedServices from './+state/pending-accepted-services/pending-accepted-services.actions';
// eslint-disable-next-line max-len
import { selectAll as selectPendingAcceptedServices } from './+state/pending-accepted-services/pending-accepted-services.interfaces';
import * as fromPendingDeclinedServices from './+state/pending-declined-services/pending-declined-services.actions';
// eslint-disable-next-line max-len
import { selectAll as selectPendingDeclinedServices } from './+state/pending-declined-services/pending-declined-services.interfaces';
import {
  roHistorySelector,
  selectAll as selectServicesDue,
  selectTotal as selectServicesDueTotal,
  roHistoryIsLoadingSelector,
  roHistoryErrorSelector,
  servicesDueLoadedSelector,
  servicesDueErrorSelector,
  ServicesDueLoadStatus,
} from './+state/services-due/services-due.interfaces';
import * as fromServicesDue from './+state/services-due/services-due.actions';
import {
  selectAll as selectTemplateDetail,
  templateDetailErrorSelector,
} from './+state/template-detail/template-detail.interfaces';
import * as fromTemplateDetail from './+state/template-detail/template-detail.actions';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { DeepCopyPipe } from '@quorum/common-pipes';
import { ResetMenuState } from './+state/vehicle-maintenance.actions';
@Injectable()
export class VehicleMaintenanceStateService {
  scheduleSavedNotification = new Subject<any>();
  declinedServicesWithReason = new Subject<any>();
  servicesDue$ = new BehaviorSubject<any>([]);
  constructor(private store: Store<any>) {}

  clearPendingAccepted() {
    this.store.dispatch(new fromPendingAcceptedServices.ClearPendingAcceptedServiceInState({}));
  }
  clearPendingDeclined() {
    this.store.dispatch(new fromPendingDeclinedServices.ClearPendingDeclinedServiceInState({}));
  }
  addAcceptedService(serviceGroup: ServiceGroup) {
    this.store.dispatch(new fromAcceptedServices.AddAcceptedServiceInState({ serviceGroup }));
  }

  addDeclinedService(serviceGroup: ServiceGroup) {
    this.store.dispatch(new fromDeclinedServices.AddDeclinedServiceInState({ serviceGroup }));
  }

  addPendingAcceptedService(serviceGroup: ServiceGroup) {
    this.store.dispatch(new fromPendingAcceptedServices.AddPendingAcceptedServiceInState({ serviceGroup }));
  }

  addPendingDeclinedService(serviceGroup: ServiceGroup) {
    this.store.dispatch(new fromPendingDeclinedServices.AddPendingDeclinedServiceInState({ serviceGroup }));
  }

  removeAcceptedService(id: string) {
    this.store.dispatch(new fromAcceptedServices.RemoveAcceptedServiceInState({ id }));
  }

  removeDeclinedService(id: string) {
    this.store.dispatch(new fromDeclinedServices.RemoveDeclinedServiceInState({ id }));
  }

  removePendingAcceptedService(id: string) {
    this.store.dispatch(new fromPendingAcceptedServices.RemovePendingAcceptedServiceInState({ id: id }));
  }

  removePendingDeclinedService(id: string) {
    this.store.dispatch(new fromPendingDeclinedServices.RemovePendingDeclinedServiceInState({ id }));
  }

  selectDeclinedServices() {
    return this.store.pipe(select(selectDeclinedServices));
  }

  selectAcceptedServices() {
    return this.store.pipe(select(selectAcceptedServices));
  }

  selectPendingAcceptedServices() {
    return this.store.pipe(select(selectPendingAcceptedServices));
  }

  selectPendingDeclinedServices() {
    return this.store.pipe(select(selectPendingDeclinedServices));
  }

  // getVehicleMaintenanceData(vehicleId: number) {
  //   return combineLatest(
  //     this.getServicesDue().pipe(
  //       map((servicesDue: any) => {
  //         let obj = [];
  //         for (var prop in servicesDue) {
  //           if (servicesDue[prop].vehicleId == vehicleId) {
  //             obj.push(servicesDue[prop]);
  //           }
  //         }
  //         return obj;
  //       })
  //     ),
  //     this.getMaintenanceSchedule().pipe(
  //       map((maintenanceSchedule: any) => {
  //         return maintenanceSchedule[vehicleId];
  //       })
  //     ),
  //     this.getTemplateDetail()
  //   );
  // }

  getServicesDue() {
    return this.store.pipe(
      select(selectServicesDue),
      filter((servicesDue: any) => {
        return !this.isEmpty(servicesDue);
      })
    );
  }

  clearServicesDue() {
    this.store.dispatch(new fromServicesDue.ClearServicesDueInState({}));
  }

  getRoHistory() {
    return combineLatest([
      this.store.pipe(select(roHistorySelector)),
      this.store.pipe(select(roHistoryIsLoadingSelector)),
    ]).pipe(
      map(([roHistory, isLoading]) => {
        return { roHistory, isLoading };
      }),
      filter((result) => {
        return result.isLoading == false;
      }),
      map((result) => {
        return new DeepCopyPipe().transform(result.roHistory);
      })
    );
  }

  getMaintenanceSchedule() {
    return this.store.pipe(
      select(selectMaintenanceSchedule),
      filter((maintenanceSchedule: any) => {
        return !this.isEmpty(maintenanceSchedule);
      })
    );
  }

  clearMaintenanceSchedule() {
    this.store.dispatch(new fromMaintenanceSchedule.ClearMaintenanceSchedulesInState({}));
  }

  getTemplateDetail() {
    return this.store.pipe(
      select(selectTemplateDetail),
      filter((templateDetail: any) => {
        return !this.isEmpty(templateDetail);
      })
    );
  }

  clearTemplateDetail() {
    this.store.dispatch(new fromTemplateDetail.ClearTemplateDetailInState({}));
  }

  getTemplateDetailError() {
    return this.store.pipe(
      select(templateDetailErrorSelector),
      filter((error: string) => {
        return error != null;
      })
    );
  }

  selectTemplateDetailError(): Observable<string | null> {
    return this.store.pipe(select(templateDetailErrorSelector));
  }

  selectServicesDueLoadStatus(): Observable<ServicesDueLoadStatus> {
    return combineLatest([
      this.store.pipe(select(servicesDueLoadedSelector)),
      this.store.pipe(select(selectServicesDueTotal)),
      this.store.pipe(select(servicesDueErrorSelector)),
    ]).pipe(map(([loaded, count, error]) => ({ loaded, count, error })));
  }

  selectRoHistoryError(): Observable<string | null> {
    return this.store.pipe(select(roHistoryErrorSelector));
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
